import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { TopRowBox } from '../topRows/topRowBox/TopRowBox';

const PnLDisplay = observer(({ tradePlanId }) => {
  const { tradePlanStore  } = useWebsocketStore();
  const positionId = tradePlanStore.tradePlans[tradePlanId].positionId;
  const unrealizedPnl = tradePlanStore.positions.tradeUnafraid[positionId]?.uPnlAtBidAsk ?? 0;
  const realizedPnl = tradePlanStore.positions.tradeUnafraid[positionId]?.realizedPnl ?? 0;

  // let uPnlClassname;
  // let rPnlClassname;

  // if (unrealizedPnl < 0) uPnlClassname = style.loss;
  // else if (unrealizedPnl === 0) uPnlClassname = style.breakEven;
  // else uPnlClassname = style.profit;

  // if (realizedPnl < 0) rPnlClassname = style.loss;
  // else if (realizedPnl === 0) rPnlClassname = style.breakEven;
  // else rPnlClassname = style.profit;

  return (
    // <div className={style.container} style={{ backgroundColor: colors.grey }}>
    //   <span className={uPnlClassname}>uPnL: {ApplyRounding(unrealizedPnl, 2)}</span>
    //   <span className={rPnlClassname}>rPnL: {ApplyRounding(realizedPnl, 2)}</span>
    // </div>
    <>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={unrealizedPnl < 0 ? colors.red : unrealizedPnl > 0 ? colors.green : colors.lightGrey}>{`uPnL: ${ApplyRounding(unrealizedPnl, 2)}`}</TopRowBox>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={realizedPnl < 0 ? colors.red : realizedPnl > 0 ? colors.green : colors.lightGrey}>{`rPnL: ${ApplyRounding(realizedPnl, 2)}`}</TopRowBox>
    </>
  );
});

PnLDisplay.propTypes = {
  tradePlanId: PropTypes.string,
};

export default PnLDisplay;
